import { LeaseCarData } from 'types';

import {
	LeaseCarDataActionTypes,
	RESET_LEASE_CAR_DATA,
	SET_LEASE_CAR_DATA,
} from '../actions/leaseCarDataActionTypes';

import { getGroupedPricePoints } from './utils';

export const initialState: LeaseCarData = null;

const leaseCarData = (
	state: LeaseCarData = initialState,
	action: LeaseCarDataActionTypes
): LeaseCarData => {
	switch (action.type) {
		case SET_LEASE_CAR_DATA:
			return {
				...state,
				...action.payload,
				privateLeaseData: {
					...action.payload.privateLeaseData,
					groupedPricePoints: getGroupedPricePoints(action.payload.privateLeaseData.pricePoints),
				},
			};
		case RESET_LEASE_CAR_DATA:
			return initialState;
		default:
			return state;
	}
};

export default leaseCarData;
